<template>
    <div id="simDistribut">
        <section>
            <div class="line">
                <label>开始ICCID：</label>
                <div>
                    <input v-model="iccidStart" type="text" placeholder="请输入开始ICCID号">
                </div>                
            </div>
            <div class="line">
                <label>结束ICCID：</label>
                <div>
                    <input v-model="iccidEnd" type="text" placeholder="请输入结束ICCID号">
                </div>                
            </div>
            <div  class="line">
                <mt-button type="primary" size="large" @click="getAgentCardListHandler">搜索</mt-button> 
            </div>            
            <div  class="line">
                <label>代理商：</label>
                <div>
                    <select v-model="agentId">
                        <option v-for="item in agentListOption" :value="item.id" :key="item.id">{{ item.name }}</option>
                    </select>                    
                </div>
            </div>   
            <div  class="line">
                <mt-button type="primary" size="large" @click="simDistributHandler">分销</mt-button> 
            </div>  
        </section>
        <section>
            <table>
                <thead>
                    <tr>
                        <th>ICCID号</th>
                        <th>分销商</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in tableData" :key="item.id">
                        <td>{{item.iccid}}</td>
                        <td>{{item.agentPathNames}}</td>
                    </tr>
                </tbody>
            </table>
        </section>
    </div>
</template>
<script>
import { wxRequest} from '@/api/agent.js'
export default {
    data(){
        return {
            iccidStart: '',
            iccidEnd: '',
            agentId: '',
            agentListOption: [],
            tableData: []
        }
    },
    methods: {
        getAgentCardListHandler(){
            var data = {};
            if(this.iccidStart){
                data.iccidStart = this.iccidStart;
            }
            if(this.iccidEnd){
                data.iccidEnd = this.iccidEnd;
            }

            wxRequest('sim/agent/listPage', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.resultList;
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        simDistributHandler(){
            var data = {
                iccidStart: this.iccidStart,
                iccidEnd: this.iccidEnd,
                agentId: this.agentId
            }
            wxRequest('sim/wx/soldList', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.getAgentCardListHandler();
                    this.$toast({
                        message: '分销完成',
                        position: 'middle',
                        duration: 1000
                    })
                }else{
                    this.$messagebox.alert(res.data.message)
                }
            })
        }
    },
    created(){
        wxRequest('agent/list', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.agentListOption = res.data.data;
            }
        });        
    }
}
</script>
<style lang="less" scoped>
#simDistribut {
    padding: 10px 3% 0;

.line {
    label {
        line-height: 40px;
    }
    div {
        input {
            padding: 6px 5px;
            border: 1px solid #bfbfbf;
            box-sizing: border-box;
        }
    }
}
    select {
        width: 100%;
        height: 40px;
        padding: 10px;
        line-height: 20px;
        background: transparent;
        border: 1px solid #bfbfbf;
    }
}
</style>
